<template>
  <div class="super-audio-bag">
    <svg-icon name="bag"></svg-icon>购买配音包
  </div>
</template>

<script>
export default {
  name: 'super-audio-bag',
  props: {
    msg: String
  },
  components: {
  },
  methods: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.super-audio-bag {
  font-size: 14px;
  color: #D5802E;
  text-align: center;
  background: #FFF5EB;
  border: 1px solid #FFD2A5;
  border-radius: 18px;
  width: 116px;
  height: 36px;
  line-height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  .svg-icon {
    width: 18px;
    margin-right: 8px;
  }
}
</style>
